import { render } from "./UnitType2List.vue?vue&type=template&id=3d531370&scoped=true"
import script from "./UnitType2List.vue?vue&type=script&lang=js"
export * from "./UnitType2List.vue?vue&type=script&lang=js"

import "./UnitType2List.vue?vue&type=style&index=0&id=3d531370&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d531370"]])

export default __exports__